export default __webpack_public_path__ + "5a05596fb88eaf3c9461d41c2208578d.png";